import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { createUserTrace } from '../../api/Optimise';
import { OnboardingContext } from '../../context/OnboardingContext';
import TariffForm from '../../ui/Form/TariffForm';
import InfoModal from '../../ui/Modal/InfoModal';
import { getFinalExportTariffId } from '../../utils/tariffUtils';

const TariffContainer = () => {
  const theme = useTheme();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { postcode, setImportTariffId, setExportTariffId, setProgressPercentage } = useContext(OnboardingContext);

  const whyNeedTariffInfo = `${theme.language.appName} needs to know the price of energy throughout the day. It only knows this if it has your tariff.`;
  const returnTo = location.state?.from || '/onboarding/pv-system';

  useEffect(() => {
    setProgressPercentage(20);
  }, [setProgressPercentage]);

  const onSelectTariff = async ({ importTariffId, exportTariffId, exportTariffs }) => {
    setImportTariffId(importTariffId);

    const finalExportTariffId = await getFinalExportTariffId(exportTariffId, postcode, exportTariffs);
    setExportTariffId(finalExportTariffId);
    await createUserTrace('Tariff', {
      importTariff: importTariffId,
      exportTariff: finalExportTariffId,
    });
    history.push(returnTo);
  };

  return (
    <>
      <InfoModal show={showInfoModal} onClose={() => setShowInfoModal(false)} infoContent={whyNeedTariffInfo} />
      <h1 className="mb-3">Your tariff details</h1>
      <p>Please enter your import and export tariff details.</p>
      <Button variant="link" onClick={() => setShowInfoModal(true)} className="mb-4 p-0 btn-link">
        Why does {theme.language.appName} need your import and export tariff?
      </Button>
      <TariffForm onSubmit={onSelectTariff} setInitialValues={true} />
    </>
  );
};

export default TariffContainer;
